import * as React from 'react';
import Box from '@mui/material/Box';
import Modal from '@mui/material/Modal';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import { Formik, Form } from 'formik';
import { Autocomplete, Checkbox, Container, FormControlLabel, IconButton, TextField, TextareaAutosize } from '@mui/material';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import { sorunTipi, aksiyonSahibi } from '../../helpers/ProcessData';
import Textarea from '@mui/joy/Textarea';
import CloseIcon from '@mui/icons-material/Close';
import HighlightOffIcon from '@mui/icons-material/HighlightOff';
import { useState, useEffect } from 'react';
import { uygunsuzlukTipi } from "../../helpers/ProcessData"
import { useSelector } from "react-redux"
import useArge from '../../hooks/useArge';


const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: '80%',
  bgcolor: 'background.paper',
  border: '2px solid #000',
  boxShadow: 24,
  p: 4,

};

const DijitalBaskiModal = ({ open, handleClose, info, setInfo, materialCode, designCode }) => {


  const nowData = new Date()
  const currentdatetime = nowData.getDate() + "-" + (nowData.getMonth() + 1) + "-" + nowData.getFullYear()
  const currentTime = nowData.getHours() + ":" + nowData.getMinutes()

  const [searchUrunKodu, setSearchUrunKodu] = useState(null)
  const [searchTasarimKodu, setSearchTasarimKodu] = useState(null)
  const [isCheck, setIsCheck] = useState(false)
  const [newMaterialName, setnewMaterialName] = useState(false)


  const handleChange = (e, newValue, fieldName) => {
    // setInfo({ ...info, [e.target.name]: e.target.value, ['urun_kodu']: search ? search.MALZEMEKODU : ""  })

    // Autocomplete'ten gelen olaylar için
    if (fieldName) {
      setInfo(prevInfo => ({
        ...prevInfo,
        [fieldName]: newValue?.MALZEMEKODU || newValue || ""
      }));
    }
    // TextField'tan gelen olaylar için
    else if (e?.target) {
      const { name, value } = e.target;

      setInfo(prevInfo => {

        const newInfo = { ...prevInfo, [name]: value }

        if (isCheck && newInfo.oldData_date) {

          const dateStr = newInfo.oldData_date.split('T')
          const parts = dateStr[0].split('-')
          newInfo.date = `${parts[2]}-${parts[1]}-${parts[0]}`
          newInfo.time = dateStr[1]
        }
        else {

          newInfo.date = currentdatetime.toString()
          newInfo.time = currentTime.toString()
        }

        //?yeni ürün kodu bilgisi manuel olarak yazılırsa ürün_kodu değerini yazdır
        if (newMaterialName) {
          newInfo.urun_kodu = newInfo.newMaterialName.toUpperCase()
        }


        return newInfo
      })

    }

  }
  const { getFireData, putFireData, postFireData } = useArge()
  const [desenCodes, setdesenCodes] = useState([])

  const handleSubmit = (e) => {

    e.preventDefault()

    if (info.id) {
      putFireData('DijitalBaski', info)
      getFireData("DijitalBaski")
    }
    else {
      postFireData("DijitalBaski", info)
      getFireData("DijitalBaski")
    }

    handleClose()

  }


  useEffect(() => {

    const data = designCode.map((item) => item.DESENKODU)
    const dataSort = data.sort()
    setdesenCodes(dataSort)

  }, [designCode])


  // checkbox fonksiyon
  const handleIsCheck = (e) => {
    const { checked, name } = e.target
    if (name === "oldData") {

      setIsCheck(checked)
    }
    else if (name === 'newMaterialName') {
      setnewMaterialName(checked)
    }
  }

  // checkbox false yap ve date bilgisini temizle
  function handleIsCheck_Reset() {
    setIsCheck(false)
    setInfo({ ...info, ['oldData_date']: "" })
  }



  return (
    <div>

      <Modal
        keepMounted
        open={open}
        onClose={() => {
          handleClose()
          handleIsCheck_Reset()
        }}
        aria-labelledby="keep-mounted-modal-title"
        aria-describedby="keep-mounted-modal-description"
      >
        <Box sx={style}>

          <Box sx={{ display: 'flex', flexWrap: 'wrap', justifyContent: 'space-between', alignItems: 'center' }}>

            <Typography id="keep-mounted-modal-title" variant="h6" component="h2" color="#000000">
              Dijital Baskı
            </Typography>

            <IconButton onClick={() => {
              handleClose()
              handleIsCheck_Reset()
            }}>
              <HighlightOffIcon sx={{ color: '#C70039', fontSize: '28px' }} />
            </IconButton>
          </Box>

          <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1, alignItems: 'center', p: 2, border: '1px solid gray', borderRadius: 3 }}>

            <Box sx={{ display: 'flex', justifyContent: 'flex-start', gap: 2, width: '100%' }}>
              <FormControlLabel
                control={
                  <Checkbox checked={isCheck} onChange={handleIsCheck} name="oldData" />
                }
                label="Geçmiş tarihli veri girişi"
              />
              {
                isCheck && <TextField
                  size='small'
                  name='oldData_date'
                  id='oldData_date'
                  type='datetime-local'
                  onChange={handleChange}
                />
              }

            </Box>
            {
              <Box sx={{ display: 'flex', justifyContent: 'flex-start', gap: 2, width: '100%' }}>
                <FormControlLabel
                  control={
                    <Checkbox checked={newMaterialName} onChange={handleIsCheck} name="newMaterialName" />
                  }
                  label="Yeni malzeme adı"
                />
                {
                  newMaterialName && <TextField
                    size='small'
                    name='newMaterialName'
                    id='newMaterialName'
                    value={info.newMaterialName}
                    type='text'
                    onChange={handleChange}
                  />
                }

              </Box>
            }

          </Box>

          <Box sx={{ mt: 3, display: 'flex', flexDirection: 'column', gap: 2, overflow: 'scroll', maxHeight: '550px' }} component='form' onSubmit={handleSubmit}>


            <Box sx={{ display: 'flex', justifyContent: 'space-between', gap: 2 }}>


              <Autocomplete
                fullWidth
                value={searchTasarimKodu}
                name='tasarim_kodu'
                onChange={(event, newValue) => {
                  setSearchTasarimKodu(newValue);
                  handleChange(event, newValue, 'tasarim_kodu')
                }}
                id="search-select-demo"
                options={desenCodes}
                getOptionLabel={(option) => option}
                renderInput={(params) => <TextField required {...params} label="Tasarım Kodu" />}
              />

              {/* yeni ürün kodu manuel olarak eklemek istenirse seçmeli ürün kodlarını görünümünü kapat */}
              {
                newMaterialName ?
                  (
                    ""
                  )
                  :
                  (
                    <Autocomplete
                      fullWidth
                      value={info.urun_kodu ? { MALZEMEKODU: info.urun_kodu } : searchUrunKodu}
                      name='urun_kodu'
                      onChange={(event, newValue) => {
                        setSearchUrunKodu(newValue);
                        handleChange(event, newValue, 'urun_kodu')
                      }}
                      id="search-select-demo"
                      options={materialCode}
                      getOptionLabel={(option) => option.MALZEMEKODU}
                      renderInput={(params) => <TextField {...params} label="Ürün Kodu" />}
                    />
                  )
              }

            </Box>



            {/* 
            <Box sx={{ display: 'flex', justifyContent: 'center', gap: 2 }}>

              <FormControl fullWidth>
                <InputLabel id="banthizi">Bant Hızı</InputLabel>
                <Select
                  labelId="banthizi"
                  id="banthizi"
                  name='banthizi'
                  label="banthizi"
                  value={info.banthizi}
                  onChange={handleChange}
                >
                  <MenuItem value="OK">OK</MenuItem>
                  <MenuItem value="NOT">NOT</MenuItem>
                </Select>
              </FormControl>

              <FormControl fullWidth>
                <InputLabel id="silimsvoltajuyu">Voltaj</InputLabel>
                <Select
                  labelId="voltaj"
                  id="voltaj"
                  name='voltaj'
                  label="voltaj"
                  value={info.voltaj}
                  onChange={handleChange}
                >
                  <MenuItem value="OK">OK</MenuItem>
                  <MenuItem value="NOT">NOT</MenuItem>
                </Select>
              </FormControl>

              <FormControl fullWidth>
                <InputLabel id="basinc">Basınç</InputLabel>
                <Select
                  labelId="basinc"
                  id="basinc"
                  name='basinc'
                  label="basinc"
                  value={info.basinc}
                  onChange={handleChange}
                >
                  <MenuItem value="OK">OK</MenuItem>
                  <MenuItem value="NOT">NOT</MenuItem>
                </Select>
              </FormControl>

            </Box> */}

            {/* <Box sx={{ display: 'flex', justifyContent: 'center', gap: 2 }}>

              <TextField
                sx={{ backgroundColor: '#78C1F3', label: { color: '#000000' } }}
                fullWidth
                label="Mavi"
                name="mavi"
                id="mavi"
                type="text"
                variant="outlined"
                value={info.mavi}
                onChange={handleChange}
              />

              <TextField
                sx={{ backgroundColor: '#EDB7ED', label: { color: '#000000' } }}
                fullWidth
                label="Pembe"
                name="pembe"
                id="pembe"
                type="text"
                variant="outlined"
                value={info.pembe}
                onChange={handleChange}
              />

              <TextField
                sx={{ backgroundColor: '#F2F7A1', label: { color: '#000000' } }}
                fullWidth
                label="Sarı"
                name="sari"
                id="sari"
                type="text"
                variant="outlined"
                value={info.sari}
                onChange={handleChange}
              />


            </Box> */}

            {/* <Box sx={{ display: 'flex', justifyContent: 'center', gap: 2 }}>

              <TextField
                sx={{ backgroundColor: '#DFA878', label: { color: '#000000' } }}
                fullWidth
                label="Kahverengi"
                name="kahverengi"
                id="kahverengi"
                type="text"
                variant="outlined"
                value={info.kahverengi}
                onChange={handleChange}
              />

              <TextField
                sx={{ backgroundColor: '#A2C579', label: { color: '#000000' } }}
                fullWidth
                label="Yeşil"
                name="yesil"
                id="yesil"
                type="text"
                variant="outlined"
                value={info.yesil}
                onChange={handleChange}
              />

              <TextField
                sx={{ backgroundColor: '#61677A', label: { color: '#000000' } }}
                fullWidth
                label="Siyah"
                name="siyah"
                id="siyah"
                type="text"
                variant="outlined"
                value={info.siyah}
                onChange={handleChange}
              />


            </Box> */}


            <Box sx={{ display: 'flex', justifyContent: 'center', gap: 2 }}>

              {/* <TextField
                fullWidth
                label="Reaktif"
                name="reaktif"
                id="reaktif"
                type="text"
                variant="outlined"
                value={info.reaktif}
                onChange={handleChange}
              /> */}

              {/* <TextField
                fullWidth
                label="Beyaz"
                name="beyaz"
                id="beyaz"
                type="text"
                variant="outlined"
                value={info.beyaz}
                onChange={handleChange}
              /> */}

              <FormControl fullWidth>
                <InputLabel id="desenGorseli">Görsel</InputLabel>
                <Select
                  labelId="desenGorseli"
                  id="desenGorseli"
                  name='desenGorseli'
                  label="desenGorseli"
                  value={info.desenGorseli}
                  onChange={handleChange}
                >
                  <MenuItem value="OK">OK</MenuItem>
                  <MenuItem value="NOT">NOT</MenuItem>
                </Select>
              </FormControl>



            </Box>


            <TextField
              multiline
              fullWidth
              label="Hata Tanımı"
              name="hataTanimi"
              id="hataTanimi"
              type="text"
              variant="outlined"
              value={info.hataTanimi}
              onChange={handleChange}
            />




            <TextField
              multiline
              fullWidth
              label="Açıklama"
              name="aciklama"
              id="aciklama"
              type="text"
              variant="outlined"
              value={info.aciklama}
              onChange={handleChange}
            />



            <Button
              variant='contained'
              fullWidth
              type='submit'
            >
              {info?.id ? "Update Data" : "Add New Data"}
            </Button>


          </Box>


        </Box>
      </Modal>
    </div>
  );
}

export default DijitalBaskiModal